import React from "react";

const ContactSocialProof = () => {
  const stats = [
    { value: "60%+", label: "average case acceptance rate with SmileReveal" },
    { value: "98.7%", label: "AI smile prediction accuracy" },
    { value: "5 min", label: "average setup time — no hardware required" },
    { value: "HIPAA", label: "compliant with AES-256 encryption" },
  ];

  return (
    <section className="py-24 px-3 sm:px-4 lg:px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16 px-4">
          <h3 className="text-2xl md:text-4xl font-bold text-[#1a1a1a] mb-6 tracking-tight leading-tight">
            Trusted by Dental Practices Nationwide
          </h3>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {stats.map((stat, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-6 text-center shadow-sm border border-slate-100 hover:border-blue-100 transition-colors"
            >
              <div className="text-3xl font-extrabold text-[#0066ff] mb-2">
                {stat.value}
              </div>
              <p className="text-sm font-medium text-slate-600">{stat.label}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 max-w-4xl mx-auto bg-white rounded-3xl p-8 md:p-12 shadow-sm border border-slate-100 text-center relative">
          <div className="absolute -top-6 left-1/2 -translate-x-1/2 bg-blue-50 text-[#0066ff] w-12 h-12 rounded-full flex items-center justify-center border-4 border-[#f4f7fb]">
            <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
              <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" />
            </svg>
          </div>
          <p className="text-lg md:text-xl font-medium text-slate-700 italic mb-6 leading-relaxed">
            "SmileReveal changed how we present implant treatment plans. Our
            case acceptance went from 35% to over 65% in the first month.
            Patients actually get excited now."
          </p>
          <div>
            <p className="font-bold text-slate-900">— Dr. Smith</p>
            <p className="text-sm text-slate-500">
              Modern Smiles Dentistry, Austin, TX
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSocialProof;
